import { render } from "./ResetPassword.vue?vue&type=template&id=2a5c1e34&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=2a5c1e34&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tend_preselect.konnektor.nl_main/node_modules/.pnpm/vue-loader@16.8.3_czxhl45dan3d4o5uu7vih6mmde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5c1e34"]])

export default __exports__